/** True when a grid month should show the roll-forward refresh blur. */
export function isClampForecastRollForwardRefreshing(
  refreshingFrom: { categoryCode: string; fromMonth: string } | null,
  categoryCode: string,
  planMonth: string,
): boolean {
  if (refreshingFrom == null) return false;
  if (refreshingFrom.categoryCode !== categoryCode) return false;
  return planMonth >= refreshingFrom.fromMonth;
}
